import { render, staticRenderFns } from "./InoustaySolutions.vue?vue&type=template&id=3a38c8c6&scoped=true&"
import script from "./InoustaySolutions.vue?vue&type=script&lang=js&"
export * from "./InoustaySolutions.vue?vue&type=script&lang=js&"
import style0 from "./InoustaySolutions.vue?vue&type=style&index=0&id=3a38c8c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38c8c6",
  null
  
)

export default component.exports